import { RefObject, useCallback, useRef } from 'react';

export const useRefArray = <T extends HTMLElement>() => {
  const refs = useRef<RefObject<T>[]>([]);

  const setRef = useCallback((index: number, node: T | null) => {
    refs.current[index] = { current: node };
  }, []);

  const getRef = useCallback((index: number) => {
    return refs.current[index];
  }, []);

  return { refs, setRef, getRef };
};
